<template>
  <v-card
    v-if="
      relatorio.dataDaOPU ||
      relatorio.dataDaTransferencia ||
      relatorio.previsaoParto
    "
    class="ma-4"
  >
    <v-card-title style="text-align: left">Datas</v-card-title>
    <v-card-text>
      <v-row class="pa-3">
        <v-col cols="12" sm="6" lg="4" class="col-bordered">
          <span class="key-title">Data da aspiração: </span> <br />
          <span class="value-title">{{
            relatorio.dataDaOPU ? relatorio.dataDaOPU : 'Não informado'
          }}</span>
        </v-col>
        <v-col cols="12" sm="6" lg="4" class="col-bordered">
          <span class="key-title">Data da transferência: </span> <br />
          <span class="value-title">{{
            relatorio.dataDaTransferencia
              ? relatorio.dataDaTransferencia
              : 'Não informado'
          }}</span>
        </v-col>
        <v-col cols="12" sm="6" lg="4" class="col-bordered">
          <span class="key-title">Data da previsão do parto: </span> <br />
          <span class="value-title">{{
            relatorio.previsaoParto ? relatorio.previsaoParto : 'Não informado'
          }}</span>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'IndicadoresQualidade',
  props: {
    relatorio: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  methods: {},
}
</script>

<style scoped>
.key-title {
  font-weight: 500;
  font-size: '16px';
}

.value-title {
  font-size: '16px';
}

.col-bordered {
  border: solid 1px #ccc;
}
</style>
